import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Vale from './Vales';
import { ValesData } from '../../types/Types';

interface Props {
  valesNoAct: ValesData[];
  retrieveValesAhorro: any;
  isMobile: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setPromocion: React.Dispatch<React.SetStateAction<boolean>>;
}
const ValesNoActivados: FC<Props> = ({
  valesNoAct,
  retrieveValesAhorro,
  isMobile,
  setVisible,
  setPromocion,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="listado-vales">
        <h2 className="bloque-datos__title u-text-brand">
          <span className="divider__square brand-color" />
          <span className="u-margin-right">{t('vales.noActivos')}</span>
        </h2>
        <div className="listado-vales__filtro" />
      </div>

      <div className="listado-vales listado-vales__activos">
        {valesNoAct.map((valeData, index) => (
          <Vale
            preActivado={false}
            key={`vale-${valeData.valeEAN}`}
            data={valeData}
            cargarVales={retrieveValesAhorro}
            valeIndex={isMobile ? 0 : index}
            showCondLegales={setVisible}
            setPromocion={setPromocion}
          />
        ))}
      </div>
    </>
  );
};

export default ValesNoActivados;
